// src/features/hospitalFavorite/hospitalFavoriteSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { HospitalFavorite } from "@/types/hospitalFavorite"

export interface HospitalFavoriteState {
  favorites: Record<string, HospitalFavorite>
  loaded: boolean
  loading: boolean
  error: string | null
}

const initialState: HospitalFavoriteState = {
  favorites: {},
  loaded: false,
  loading: false,
  error: null,
}

const hospitalFavoriteSlice = createSlice({
  name: "hospitalFavorite",
  initialState,
  reducers: {
    loadFavoritesStart: state => {
      state.loading = true
      state.error = null
    },
    loadFavoritesSuccess: (state, action: PayloadAction<HospitalFavorite[]>) => {
      state.loading = false
      state.loaded = true
      state.error = null
      state.favorites = action.payload.reduce((acc, favorite) => {
        acc[favorite.hospitalFavoriteName] = favorite
        return acc
      }, {} as Record<string, HospitalFavorite>)
    },
    loadFavoritesFailure: (state, action: PayloadAction<string>) => {
      state.loading = false
      state.error = action.payload
    },
    updateFavorite: (state, action: PayloadAction<HospitalFavorite>) => {
      state.favorites[action.payload.hospitalFavoriteName] = action.payload
    },
    deleteFavorite: (state, action: PayloadAction<string>) => {
      delete state.favorites[action.payload]
    },
    resetFavorites: () => initialState,
  },
})

export const { loadFavoritesStart, loadFavoritesSuccess, loadFavoritesFailure, updateFavorite, deleteFavorite, resetFavorites } =
  hospitalFavoriteSlice.actions

export default hospitalFavoriteSlice.reducer
